<template>
  <div class="chat-history-edit-message-history">
    <Modal
      v-if="modalFlag"
      :class="'modal--dialog modal--booking'"
      :header="false"
      :booking-header="true"
      @close-modal="setShowMessageHistory(false)"
    >
      <template #custom-header>
          <div class="modal-header">
            <h2 class="modal-heading">History of Edited Messages</h2>
            <button type="button" @click="closeMessageHistory()">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="13.261"
                height="13.26"
                viewBox="0 0 13.261 13.26"
              >
                <g transform="translate(3.671 -2.369) rotate(45)">
                  <line
                    x2="16.752"
                    transform="translate(8.456 -4.106) rotate(90)"
                    fill="none"
                    stroke-width="2"
                  />
                  <line
                    x2="16.752"
                    transform="translate(0.079 4.271)"
                    fill="none"
                    stroke-width="2"
                  />
                </g>
              </svg>
              <span class="close-text">Close</span>
            </button>
          </div>
      </template>
      <section class="section-container">

        <el-row>

            <perfect-scrollbar class="chat_ui scrollable">
                <div class="inner_chat_ui adjustment">
                    <div v-for="(item, index) in historyMessages.message_history" :key="index">
                        <div class="received_chat">
                        <span class="received_icon">
                            {{ getFirstLetterNickName(historyMessages.nickname) }}
                        </span>

                        <div class="chat_main received_chat_main">
                            <span class="chat_received_time">
                                {{ item.dateTime.localeTime }}
                            </span>
                            <div class="chat_received_balloon history_balloon">
                                <p v-dompurify-html="item.message"></p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </perfect-scrollbar>

        </el-row>
      </section>

    </Modal>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Modal from '@/components/Templates/Modal';
import ChatHistory from '@/mixins/chatHistory';
import UserLocalTimezone from '@/mixins/userLocalTimezone';

export default {
  mixins: [
    ChatHistory,
    UserLocalTimezone
  ],
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  components: { 
    Modal, 
  },
  data: () => {
    return {
      modalFlag: false,
      historyMessages: [],
    };
  },
  watch: {
    modalShow(value) {
      this.modalFlag = value;
      if (this.modalFlag) {
        this.fetchChatEditHistory();
      } else {
        this.historyMessages = [];
        this.setCurrentChatHistoryId(null);
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['setShowMessageHistory']),
    ...mapMutations('chatHistory', ['setCurrentChatHistoryId']),
    closeMessageHistory() {
      this.setShowMessageHistory(false);
      this.historyMessages = [];
    },
    async fetchChatEditHistory() {
      this.historyMessages = await this.fetchChatEditsHistory({ lessonId: this.lessonId, messageId: this.currentChatHistoryId });
      let vueInstance = this;
      this.historyMessages.message_history.forEach(function(data, index, array) {
        array[index].dateTime = vueInstance.toLocal(data.date_time);
      });
    },
  },
  computed: {
    ...mapState('chatHistory', ['lessonId', 'currentChatHistoryId']),

    getFirstLetterNickName() {
        return function (name) {
            return name?.charAt(0).toUpperCase();
        }
    },
  },
};
</script>
